import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGenders } from "../actions/genderActions";

const Gender = React.memo(() => {
  const dispatch = useDispatch();

  const genderList = useSelector((state) => state.genderList);
  const { genders, loading, error } = genderList;

  useEffect(() => {
    if (!genders) {
      dispatch(getGenders());
    }
  }, [genders]);
  return (
    <>
      {loading ? (
        <>loading...</>
      ) : (
        <>
          {genders ? (
            genders.map((gend, i) => (
              <option key={gend.Id} value={gend.Id}>
                {gend.Gender}
              </option>
            ))
          ) : (
            <>
              <option>Loading...</option>
            </>
          )}
        </>
      )}
    </>
  );
});

export default Gender;
